import ApiBase from 'app/services/api/entities/Base'
import api from '../api'

const getRfc = (token) => {
  return api.privateGet(`v1/rfc/`, {token})
}

function* rfc() {
  return yield ApiBase.privateGet('/v1/rfc/')
}

function* updateRFC(data) {
  return yield ApiBase.privatePatch('/v1/rfc/update_rfc/', { data })
}

export default {
  rfc,
  getRfc,
  updateRFC
}
